import React, { useState } from "react";
import { BsEmojiSmile, BsArrowUp } from "react-icons/bs";
import EmojiPicker from "emoji-picker-react";

export default function ChatForm({ onHandleSubmit, chatBotSetting, disabled }) {
  const [question, setQuestion] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const busy = disabled || submitting;

  const onSubmit = async (event) => {
    event.preventDefault();
    if (!question.trim() || busy) return;
    const currentQuestion = question.trim();
    setSubmitting(true);
    setError("");
    try {
      await onHandleSubmit(currentQuestion);
      setQuestion("");
      setShowEmojiPicker(false);
    } catch {
      setError("Your message couldn't be sent. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="chat-composer">
      <div className="chat-composer-field" style={{ backgroundColor: chatBotSetting.sendBarBackgroundColor }}>
        <input
          type="text"
          maxLength={500}
          autoComplete="off"
          name="chat-text-input"
          aria-label="Message"
          placeholder={chatBotSetting.inputPlaceHolder || "Type a message…"}
          value={question}
          disabled={submitting}
          onChange={(event) => setQuestion(event.target.value)}
          className="chat-composer-input"
        />
        <div className="flex items-center gap-1 shrink-0">
          <button type="button" onClick={() => setShowEmojiPicker((prev) => !prev)} className="chat-icon-button" aria-label="Choose emoji" aria-expanded={showEmojiPicker} disabled={submitting}>
            <BsEmojiSmile size={18} />
          </button>
          {showEmojiPicker && (
            <div className="chat-emoji-picker" onKeyDown={(event) => { if (event.key === "Escape") setShowEmojiPicker(false); }}>
              <EmojiPicker width="100%" height={350} onEmojiClick={(event) => {
                setQuestion((prev) => (prev + event.emoji).slice(0, 500));
                setShowEmojiPicker(false);
              }} />
            </div>
          )}
          <button type="submit" className="chat-send-button" aria-label="Send message" disabled={!question.trim() || busy}>
            <BsArrowUp size={20} />
          </button>
        </div>
      </div>
      {error && <p className="chat-error" role="alert">{error}</p>}
    </form>
  );
}
